import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import PubSub, { topics } from '../../lib/pubsub';

import Input from '../form/input';
import TagTree from './tree';

import util from '../../lib/util';
import style from './style.css';

const initialState = {
    height: 100,
    windowHeight: 0,
    loading: false,
    view: {
        countries: false,
        languages: false,
        brands: false,
    },
};

@observer
class TagList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
        };
        this.updateTimer = {};

        const { tagStore } = this.props.stores;
        tagStore.list(false, { addData: ['tagListTree'] });
        this.subscriptions();
    }

    subscriptions() {
        PubSub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, (height) => {
            this.setState({ height });
        });
    }

    handleScroll = () => {
        const { loading } = this.state;
        const { tagStore } = this.props.stores;
        const { totalAppend, limit } = tagStore;
        if (window.innerHeight + document.documentElement.scrollTop + 500
            < document.documentElement.offsetHeight) return;
        if (loading) return;

        let offset = tagStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(this.scrollLoader);
            this.scrollLoader = setTimeout(async () => {
                this.setState({ loading: true });
                tagStore.updateOffset(offset);
                await tagStore.list(true);
                this.setState({ loading: false });
            }, 500);
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    async updateField(id, field, value) {
        const { tagStore } = this.props.stores;
        tagStore.updateField(id, field, value);

        clearTimeout(this.updateTimer[field]);
        this.updateTimer[field] = setTimeout(async () => {
            this.doUpdateField(id, field, value);
        }, 500);
    }

    async doUpdateField(id, field, value) {
        const { tagStore } = this.props.stores;
        await tagStore.saveField(id, field, value);
    }

    render() {
        const { loading, height } = this.state;
        const { tagStore } = this.props.stores;
        const { tags, queryFilter, saved } = tagStore;

        return (
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-12'>
                        <small class='text-muted font-weight-lighter float-right mr-2'>
                            Total: {tagStore.total}<br />
                        </small>

                        <span class='float-left form-row align-items-center mr-5'>
                            <div class='col-auto'>
                                <input type='text' class='form-control form-control-sm' id='inlineFormInputName' placeholder='Search for tags...'
                                    onInput={e => tagStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true })}
                                    value={queryFilter.search}
                                />
                            </div>
                            <div class='col-auto'>
                                <button type='button' class='btn btn-sm btn-primary' onClick={() => tagStore.list()}>Search</button>
                            </div>
                        </span>
                    </div>
                </div>
                <div class='row'>
                    <div class='col-2 fixed-top overflow-auto'
                        style={`margin-top: ${height + 60}px; height: calc(100% - ${height + 60}px);`}
                    >
                        <small>
                            <TagTree {...this.props} />
                        </small>
                        <div class='text-center mt-4 mb-2'>
                            <small class='text-muted'>
                                <i class='fas fa-ellipsis-h' />
                            </small>
                        </div>
                    </div>
                    <div class='col-10 offset-2'>

                        {queryFilter.search && <div class='w-100 text-left mt-2 mb-5'>
                            <h1><i class='fas fa-search' /> Search results</h1>
                            Found {tagStore.total || 0} results in your search for "{queryFilter.search}".<br />
                            <button class='btn btn-sm btn-warning mt-2'
                                onClick={() => tagStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true })}
                            >
                                <i class='fas fa-times' /> Reset search
                            </button>
                        </div>}

                        <div class='table-responsive'>
                            <table class={`${style.table} table table-striped table-sm table-borderless`}>
                                <thead>
                                    {tagStore.sort !== tagStore.defaultSort && <tr>
                                        <th colspan='8'>
                                            <span class={`${style.pointerCursor} mr-2 badge badge-pill badge-secondary`} onClick={() => tagStore.resetSort()}>
                                                <i class='fas fa-times-circle' /> Reset sort
                                            </span>
                                        </th>
                                    </tr>}
                                    <tr>
                                        <th style='width: 5%' class='text-right'>
                                            <span class={style.pointerCursor} onClick={() => tagStore.toggleSort('id', '-')}>
                                                Tag# {util.getSortIcon('id', tagStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%' class='text-right'>
                                            <span class={style.pointerCursor} onClick={() => tagStore.toggleSort('parent', '-')}>
                                                Parent # {util.getSortIcon('parent', tagStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 55%'>
                                            <span class={style.pointerCursor} onClick={() => tagStore.toggleSort('name', '')}>
                                                Name {util.getSortIcon('name', tagStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%'>
                                            <span class={style.pointerCursor} onClick={() => tagStore.toggleSort('sort', '')}>
                                                Sort {util.getSortIcon('sort', tagStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%'>
                                            <span class={style.pointerCursor} onClick={() => tagStore.toggleSort('alias', '')}>
                                                Alias {util.getSortIcon('alias', tagStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%'>
                                            <span class={style.pointerCursor} onClick={() => tagStore.toggleSort('filter', '-')}>
                                                Filter {util.getSortIcon('filter', tagStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%' class='text-center'>
                                            <span class={style.pointerCursor} onClick={() => tagStore.toggleSort('pinned', '-')}>
                                                Pinned {util.getSortIcon('pinned', tagStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%' class='text-center'>
                                            <span class={style.pointerCursor} onClick={() => tagStore.toggleSort('menu', '-')}>
                                                Menu {util.getSortIcon('menu', tagStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 10%' class='text-right'>
                                            <span class={style.pointerCursor} onClick={() => tagStore.toggleSort('create_date', '-')}>
                                                Created {util.getSortIcon('create_date', tagStore.sort)}
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!tags.length && <tr class={`${style.tableline}`}>
                                        <td class='text-center' colspan='9'><h5>No tags found</h5></td>
                                    </tr>}
                                    {tags && tags.map(tag => (
                                        <tr class={`${style.tableline}`}>
                                            <td class='text-right'>
                                                {tag.id}
                                            </td>
                                            <td class='text-right'>
                                                <a href={`/tags/${tag.parent}/Basics`}>{tag.parent}</a>
                                            </td>
                                            <td>
                                                <a href={`/tags/${tag.id}/Basics`}>{tag.name}</a>
                                            </td>
                                            <td class='text-right'>
                                                <Input
                                                    id={tag.id}
                                                    className='text-right form-control-sm'
                                                    isValid={saved[`sort.${tag.id}`]}
                                                    name='sort'
                                                    value={tag.sort}
                                                    onInput={e => this.updateField(tag.id, 'sort', e.target.value)}
                                                    hideHelp={1}
                                                />
                                            </td>
                                            <td>
                                                {tag.alias}
                                            </td>
                                            <td class='text-center'>
                                                <span
                                                    class={`mr-1 badge ${style.pointerCursor} badge-${util.colorClass(tag.filter, 'yesno')}`}
                                                    onClick={() => tagStore.saveField(tag.id, 'filter', util.cyclevalues(tag.filter, [0, 1]), true)}
                                                >
                                                    {util.statusText(tag.filter, 'yesno')}
                                                </span>
                                            </td>
                                            <td class='text-center'>
                                                <span
                                                    class={`mr-1 badge ${style.pointerCursor} badge-${util.colorClass(tag.pinned, 'yesno')}`}
                                                    onClick={() => tagStore.saveField(tag.id, 'pinned', util.cyclevalues(tag.pinned, [0, 1]), true)}
                                                >
                                                    {util.statusText(tag.pinned, 'yesno')}
                                                </span>
                                            </td>
                                            <td class='text-center'>
                                                <span
                                                    class={`mr-1 badge ${style.pointerCursor} badge-${util.colorClass(tag.menu, 'yesno')}`}
                                                    onClick={() => tagStore.saveField(tag.id, 'menu', util.cyclevalues(tag.menu, [0, 1]), true)}
                                                >
                                                    {util.statusText(tag.menu, 'yesno')}
                                                </span>
                                            </td>
                                            <td class='text-right'>
                                                {util.ffeDateTime(tag.create_date)}
                                                {tag.updated && <div><small class='text-muted'><i class='fas fa-edit' /> {util.ffeDateTime(tag.updated)}</small></div>}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
                {loading && <div class='row'>
                    <div class='col-12 text-center'>
                        <div class='spinner-border text-success' role='status'>
                            <span class='sr-only'>Loading...</span>
                        </div>
                    </div>
                </div>}
                <div class='text-center mt-4 mb-2'>
                    <small class='text-muted'>
                        <i class='fas fa-ellipsis-h' />
                    </small>
                </div>
            </div>
        );
    }
}

export default TagList;




// WEBPACK FOOTER //
// ./components/tags/list.js